import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const ContraPurpleLogoIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 15 15",
    },
    <path
      fill="#6A57E3"
      d="M8.05 7.093h6.81a.14.14 0 0 0 .14-.14v-.209a.14.14 0 0 0-.105-.135A9.12 9.12 0 0 1 8.355.104.14.14 0 0 0 8.22 0h-.17a.14.14 0 0 0-.14.14v6.813c0 .078.063.14.14.14M8.05 15h.209a.14.14 0 0 0 .135-.105 9.12 9.12 0 0 1 6.502-6.544.14.14 0 0 0 .104-.135v-.17a.14.14 0 0 0-.14-.14H8.05a.14.14 0 0 0-.14.14v6.814c0 .077.063.14.14.14M6.78 15h.17a.14.14 0 0 0 .14-.14V8.047a.14.14 0 0 0-.14-.14H.14a.14.14 0 0 0-.14.14v.208c0 .064.043.12.105.136a9.12 9.12 0 0 1 6.54 6.505.14.14 0 0 0 .135.104M.14 7.093h6.81a.14.14 0 0 0 .14-.14V.14A.14.14 0 0 0 6.95 0H6.74a.14.14 0 0 0-.135.105A9.12 9.12 0 0 1 .104 6.65.14.14 0 0 0 0 6.784v.17c0 .077.063.14.14.14"
    />
  );
